import { useEffect } from 'react';
import { generatePath, useParams, useRouteMatch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import messages from 'messages';
import {
  ActionButton,
  Panel,
  PanelBody,
  PanelTitle,
  PanelTitleButton,
  PanelTitleButtonsGroup,
  PanelTitleWrapper,
  RefactoredPanelHeader
} from 'components/panel';

import {
  ROUTE_EXERCISES,
  ROUTE_EXERCISES_TEMPLATES_ENTITY,
  ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE,
  ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_DETAILS,
  ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_DETAILS_EDIT
} from 'routes/RouteList';
import { Breadcrumb, Breadcrumbs } from 'components/breadcrumbs';
import { Tabs, TabPanelBody } from 'components/tabs';
import { TabList, TabPanel } from 'react-tabs';
import Loader from 'components/loader/Loader';
import useTemplate from 'hooks/queries/useTemplate';
import RetryPanel from 'containers/partials/error-boundary/RetryPanel';
import { useStore } from 'stores/Store';
import TabLink from 'components/tabs/TabLink';
import TemplateExercisesTab from 'containers/pages/exercises/templates/TemplateExercisesTab';
import TemplateDetailsTab from 'containers/pages/exercises/templates/TemplateDetailsTab';
import useTabIndex from 'hooks/utils/useTabIndex';
import ContextMenu from 'components/menu/ContextMenu';
import ContextMenuWrapper from 'components/menu/ContextMenuWrapper';

const Template = () => {
  const { entityId, templateId } = useParams();
  const { fetchTemplate, loading, error } = useTemplate();
  const template = useStore(state => state.template);

  const [tabIndex, setTabIndex] = useTabIndex([
    ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE,
    [
      ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_DETAILS,
      ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_DETAILS_EDIT
    ]
  ]);
  const active = useRouteMatch([
    ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE,
    ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_DETAILS,
    ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_DETAILS_EDIT
  ]);

  useEffect(() => {
    if (templateId) {
      fetchTemplate({ variables: { templateId } });
    }
  }, [templateId]);

  if (loading || !template)
    return (
      <Panel active={active.isExact}>
        <Loader />
      </Panel>
    );
  if (error) return <RetryPanel />;

  return (
    <Panel active={active.isExact}>
      <RefactoredPanelHeader>
        <PanelTitleWrapper>
          <Breadcrumbs>
            <Breadcrumb to={ROUTE_EXERCISES}>
              <FormattedMessage {...messages.breadcrumbOverview} />
            </Breadcrumb>
            <Breadcrumb
              to={ROUTE_EXERCISES_TEMPLATES_ENTITY.replace(
                ':entityId',
                entityId
              )}
            >
              <FormattedMessage {...messages.breadcrumbTemplates} />
            </Breadcrumb>
          </Breadcrumbs>
          <PanelTitle noSubtitle>{template.title}</PanelTitle>
        </PanelTitleWrapper>
        <PanelTitleButtonsGroup>
          <ActionButton />
          <ContextMenuWrapper trigger={<PanelTitleButton />}>
            <ContextMenu />
          </ContextMenuWrapper>
        </PanelTitleButtonsGroup>
      </RefactoredPanelHeader>
      <PanelBody>
        <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
          <TabList>
            <TabLink
              to={generatePath(ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE, {
                entityId,
                templateId
              })}
            >
              <FormattedMessage {...messages.exercisesTitle} />
            </TabLink>
            <TabLink
              to={generatePath(
                ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_DETAILS,
                {
                  entityId,
                  templateId
                }
              )}
            >
              <FormattedMessage {...messages.exerciseDetails} />
            </TabLink>
          </TabList>

          <TabPanel>
            <TabPanelBody
              withHeader
              style={{
                //   overflow: 'visible',
                padding: 0,
                margin: '0 -16px',
                maxHeight: '100%'
              }}
            >
              <TemplateExercisesTab />
            </TabPanelBody>
          </TabPanel>
          <TabPanel>
            <TabPanelBody>
              <TemplateDetailsTab />
            </TabPanelBody>
          </TabPanel>
        </Tabs>
      </PanelBody>
    </Panel>
  );
};

export default Template;
